import { commonUtils } from './common_utils';
import { counters } from './counters';

const MAX_MESSAGE_LENGTH = 1000;
const contactRequest = {
    scrollToContactButton() {
        if ($('#contact_block').length) {
            $('html, body').animate({ scrollTop: $('#contact_block').offset().top }, 500);
        }
    },
    displayContactRequestOrConversationFormHtml(formHtml) {
        if ($('#conversationBlock').length) {
            $('#sellerContactFormSection').addClass('actived_contact_form');
            $('.vifContactBottomButton').addClass('actived_contact_btn');
            $('#conversationBlock')
                .html(formHtml)
                .slideDown(400, function () {
                    contactRequest.scrollToContactButton();
                });
        } else if ($('#contactRequestBlock').length) {
            $('.dealerContactButtonHolder').addClass('seller_make_sale_btn actived_contact_form');
            $('.vifContactBottomButton').addClass('actived_contact_btn');
            $('#contactRequestBlock')
                .html(formHtml)
                .slideDown(400, function () {
                    contactRequest.scrollToContactButton();
                });
        }
    },
    handleAjaxRequestFailure() {
        if (globalThis.location.hash === '#show_contact') {
            globalThis.location.hash = '';
        }
        globalThis.location.reload();
    },
    hideShowConversationBlocks(hideBlockId, showBlockId) {
        $(`#${hideBlockId}`).hide();
        $(`#${showBlockId}`).show();

        contactRequest.scrollToContactButton();
    },
};

export const sellerInboxConversation = {
    openFrom(_errorMessage = '') {
        let openConversationFrom = $('.openConversationFrom');
        let defaultMessage = openConversationFrom.data('message');
        let subjectId = Number.parseInt(openConversationFrom.data('adid'), 10);
        let adType = openConversationFrom.data('adtype') ?? '';
        let adYear = openConversationFrom.data('adyear') ?? '';

        if (isNaN(subjectId) || subjectId <= 0) {
            return false;
        }

        if ($('#conversationBlock').is(':visible') === false) {
            $.ajax({
                url: Routing.generate('inbox_conversation_form', {
                    subjectId,
                    adType,
                    adYear,
                }),
            })
                .done(function (data) {
                    contactRequest.displayContactRequestOrConversationFormHtml(data);
                    $('#conversationFormBlock #conversationMessage').html(defaultMessage);
                    commonUtils.showTextAreaLimitText('conversationMessage', 'charCounter', 1000);
                })
                .fail(function () {
                    contactRequest.handleAjaxRequestFailure();
                });
        } else {
            contactRequest.scrollToContactButton();
        }

        if ($('#conversationMessage').length) {
            commonUtils.showTextAreaLimitText('conversationMessage', 'charCounter', 1000);
        }

        return undefined;
    },
    create(params) {
        let submitButton = $('#conversationForm input[type="submit"]');
        submitButton.prop('disabled', true);
        let messageField = $('#conversationMessage');
        if ($.trim(messageField.val()) === '') {
            messageField.focus().closest('.highlightInput').addClass('error_highlight');
            submitButton.prop('disabled', false);
        } else if (messageField.val().length > MAX_MESSAGE_LENGTH) {
            messageField.focus().closest('.highlightInput').addClass('error_highlight');
            submitButton.prop('disabled', false);
            alert(Translations.message_length_error);
        } else {
            messageField.closest('.highlightInput').removeClass('error_highlight');
            $('#conversationSendingBlock').css('height', $('#conversationFormBlock').height());

            $.ajax({
                type: 'POST',
                beforeSend() {
                    contactRequest.hideShowConversationBlocks('conversationFormBlock', 'conversationSendingBlock');
                },
                url: Routing.generate('inbox_create_conversation'),
                data: params,
            })
                .done(function (data) {
                    if (data.error) {
                        $('.inbox-conversation__warning-msg').show();
                        $('#conversationFormError').html(data.error);
                        submitButton.prop('disabled', false);
                        contactRequest.hideShowConversationBlocks('conversationSendingBlock', 'conversationFormBlock');
                    } else if (data.success) {
                        let adId = Number.parseInt($('#subjectId').val(), 10);
                        const inboxBaseUrl = $('#inboxConversationSuccessUrlDiv').data(
                            'inbox-conversation-success-url'
                        );
                        const inboxUrl = `${inboxBaseUrl}/keskustelu/${data.conversationUuid}`;
                        counters.incrementByAdId('vif-contact-request', adId);
                        counters.incrementByType('contact-request-seller');
                        counters.incrementByType('contact-request-desktop');
                        $('#inboxConversationSuccessUrl').attr('href', inboxUrl);

                        contactRequest.hideShowConversationBlocks(
                            'conversationSendingBlock',
                            'conversationSuccessBlock'
                        );
                        commonUtils.dataLayer.contactRequest();
                    }
                })
                .fail(function () {
                    contactRequest.handleAjaxRequestFailure();
                });
        }
        return false;
    },
};

const dealerContactRequest = {
    openForm() {
        if ($('#contactRequestFormBlock').is(':visible')) {
            commonUtils.showTextAreaLimitText('message', 'charCounter', 1000);
            contactRequest.scrollToContactButton();
            return false;
        }

        let openContactRequestForm = $('.openContactRequestForm');
        let siteCode = openContactRequestForm.data('sitecode');
        let adId = Number.parseInt(openContactRequestForm.data('adid'), 10);
        let defaultMessage = openContactRequestForm.data('message');
        let adYear = openContactRequestForm.data('adyear') ?? '';

        if (isNaN(adId) || adId <= 0) {
            return false;
        }

        $.ajax({
            url: Routing.generate('contact_request_open_form', {
                siteCode,
                adId,
                adYear,
            }),
        })
            .done(function (response) {
                contactRequest.displayContactRequestOrConversationFormHtml(response);
                $('#contactRequestBlock #message').html(defaultMessage);
                commonUtils.loadTurnstileScriptAndRenderWidget('#contactRequestCloudFlareTurnstile');
                commonUtils.showTextAreaLimitText('message', 'charCounter', 1000);
            })
            .fail(function () {
                contactRequest.handleAjaxRequestFailure();
            });

        return undefined;
    },
    validateContactInfo(contactFieldId) {
        let contactField = $(`#${contactFieldId}`);
        if (contactField.is(':visible') === false) {
            return undefined;
        }

        let username = $('#username').val();
        let emailAddress = $('#emailAddress').val();
        let phone = $('#phone').val();
        let message = $('#message').val();
        switch (contactFieldId) {
            case 'username':
                if (commonUtils.isEmpty(username)) {
                    return contactFieldId;
                }
                break;
            case 'emailAddress':
                if (commonUtils.isEmpty(emailAddress) || !commonUtils.isValidEmail(emailAddress)) {
                    return contactFieldId;
                }
                break;
            case 'phone':
                if (commonUtils.isEmpty(phone) || !commonUtils.isValidPhone(phone)) {
                    return contactFieldId;
                }
                break;
            case 'message':
                if (commonUtils.isEmpty(message)) {
                    return contactFieldId;
                }
                break;
            default:
                break;
        }

        return undefined;
    },
    validate() {
        let errorField;
        $('.validateChange').each(function () {
            errorField = dealerContactRequest.validateContactInfo(this.id);
            if (errorField) {
                $(`#${errorField}`).focus().closest('.highlightInput').addClass('error_highlight');
                return false;
            }

            return undefined;
        });

        return !errorField;
    },
    send(params) {
        let submitButton = $('#contactRequestForm input[type="submit"]');
        submitButton.prop('disabled', true);

        let messageField = $('#message');
        if ($.trim(messageField.val()) === '') {
            messageField.focus().closest('.highlightInput').addClass('error_highlight');
            submitButton.prop('disabled', false);
        } else if (messageField.val().length > MAX_MESSAGE_LENGTH) {
            messageField.focus().closest('.highlightInput').addClass('error_highlight');
            submitButton.prop('disabled', false);
            alert(Translations.message_length_error);
        } else {
            messageField.closest('.highlightInput').removeClass('error_highlight');
            $('#contactRequestSendingBlock').css('height', $('#contactRequestFormBlock').height());

            $.ajax({
                type: 'POST',
                beforeSend() {
                    contactRequest.hideShowConversationBlocks('contactRequestFormBlock', 'contactRequestSendingBlock');
                },
                url: Routing.generate('contact_request_create_conversation'),
                data: params,
            })
                .done(function (data) {
                    if (data.error) {
                        let errorMessage = typeof data.error !== 'object' ? data.error : '';
                        if (errorMessage === '') {
                            $.each(data.error, function (_key, value) {
                                errorMessage += `${value}<br/>`;
                            });
                        }
                        $('#contactRequestFormError').html(errorMessage);
                        submitButton.prop('disabled', false);
                        contactRequest.hideShowConversationBlocks(
                            'contactRequestSendingBlock',
                            'contactRequestFormBlock'
                        );
                    } else if (data.success) {
                        let adId = Number.parseInt($('#subjectId').val(), 10);
                        counters.incrementByAdId('vif-contact-request', adId);
                        counters.incrementByType('contact-request-dealer');
                        counters.incrementByType('contact-request-desktop');

                        contactRequest.hideShowConversationBlocks(
                            'contactRequestSendingBlock',
                            'contactRequestSuccessBlock'
                        );
                        commonUtils.dataLayer.contactRequest();
                    }
                })
                .fail(function () {
                    contactRequest.handleAjaxRequestFailure();
                });
        }
        return false;
    },
};

const adExchange = {
    getForm() {
        if (adExchange.adExchangeFormHtml) {
            adExchange.resetForm();
        } else {
            $('.global-loader-img-big').show();
            $.ajax({
                url: Routing.generate('exchange_ad_form'),
            })
                .done(function (responseHtml) {
                    $('.global-loader-img-big').hide();
                    $('#conversationExchangeFormBlock').html(responseHtml);
                    adExchange.showModal();

                    // Set global variable to prevent ajax call
                    adExchange.adExchangeFormHtml = $('#conversationExchangeFormBlock').html();
                })
                .fail(function () {
                    $('.global-loader-img-big').hide();
                    contactRequest.handleAjaxRequestFailure();
                });
        }
    },
    showModal() {
        globalThis.$.colorbox({
            href: '#conversationExchangeFormBlock',
            inline: true,
            overlayClose: false,
            escKey: false,
            closeButton: false,
        });
    },
    resetForm() {
        if (adExchange.adExchangeFormHtml) {
            $('#conversationExchangeFormBlock').html(adExchange.adExchangeFormHtml);
            adExchange.showModal();
        }
    },
    fillFormByAd(exchangeAd) {
        $.each(exchangeAd, function (field, value) {
            if ($(`.ad-exchange #exchange_${field}`).length) {
                $(`.ad-exchange #exchange_${field}`).val(value);
                $(`.ad-exchange .block_${field}`).show();
            }
        });
    },
    getAdByRegNoOrId() {
        let adId = $('#conversationExchangeRegNoOrId').val().trim();
        let pathSegments = globalThis.location.pathname.split('/');
        let vifAdId = pathSegments[pathSegments.length - 1];

        // return process if process for same Ad Id
        let conversationExchangeRegNoOrIdAd = $('#conversationExchangeRegNoOrId').data('ad');
        if (conversationExchangeRegNoOrIdAd !== undefined) {
            if (
                conversationExchangeRegNoOrIdAd.id === adId ||
                conversationExchangeRegNoOrIdAd.registerNumber === adId
            ) {
                return false;
            }
        }

        adExchange.resetElements();
        if (adId) {
            $.ajax({
                url: Routing.generate('search_exchange_ad', { ad_id: adId }),
            })
                .done(function (ad) {
                    $('#exchangeRegNoOrIdLoader').hide();
                    // Note: Don't use === for compare ad.id !== vifAdId
                    if (ad.id !== undefined && String(ad.id) !== vifAdId) {
                        $('#conversationExchangeAd').val('');
                        $('#conversationExchangeRegNoOrId').data('ad', ad);
                        adExchange.fillFormByAd(ad);

                        $('#exchangeRegNoOrIdLoader').hide();
                        $('#validRegnoIdMark').removeClass('result_img_wrong').addClass('result_img_right');
                    } else if (/^\d*$/.test(adId)) {
                        // If adId not found from DB then clear value of "Reg.No/ID" & other input field
                        $('#conversationExchangeRegNoOrId').val('');
                        $('.exchange_input_container input').val('');
                        $('#conversationExchangeAd').val('');
                    } else {
                        // Allow the exchange of vehicle with reg-no,which is not in our db (Task-9373) So,clear other input fields
                        $('#conversationExchangeAd').val('');
                        $('.exchange_input_container input').val('');
                    }
                })
                .fail(function () {
                    $('#conversationExchangeRegNoOrId').val('');
                    $('#exchangeRegNoOrIdLoader').hide();
                });
        }

        return undefined;
    },
    selectOwnAd() {
        try {
            $('#conversationExchangeRegNoOrId').val('');
            adExchange.resetElements();

            let exchangeAd = $('#conversationExchangeAd option:selected').data('ad');

            $('.exchange_input_container [id^=exchange_]').val('');
            $('.exchange_input_container div[class^="block_"]').hide();

            // Show default field for no ad selection
            if ($('#conversationExchangeAd').val() === '') {
                let adExchangeFields = $('#adExchangeFields').data('ad-exchange-fields');
                $.each(adExchangeFields, function (_index, field) {
                    $(`.ad-exchange .${field}`).show();
                });
            }

            // Show site specific fields
            adExchange.fillFormByAd(exchangeAd);

            globalThis.$.colorbox.resize();
        } catch (_e) {
            globalThis.location.reload();
        }
    },
    resetElements() {
        $('#conversationExchangeRegNoOrId').data('ad', '');
        $('#exchangeRegNoOrIdLoader').hide();
        $('#adExchangeIdRegNo').text('').hide();
        $('#validRegnoIdMark').removeClass('result_img_right').addClass('result_img_wrong');
        $('.block_make,.block_regno,.block_model,.block_mileage,.block_year').removeClass('error_highlight');
    },
    cancel() {
        if (adExchange.adExchangeFormHtml) {
            $('#conversationExchangeFormBlock').html(adExchange.adExchangeFormHtml);
        }

        $('#adExchangeIdRegNo').text('').hide();
        $('.exchange_input_container input').val('');
        $('#contact_info_re, #conversationHasExchange').prop('checked', false);
        $('#conversationExchangeAdJson').val('');

        globalThis.$.colorbox.close();
    },
    validate() {
        let conversationExchangeRegNoOrId = $('#conversationExchangeRegNoOrId');
        if (
            conversationExchangeRegNoOrId.is(':visible') &&
            $('#conversationExchangeRegNoOrId').data('is-mandatory-regno') &&
            conversationExchangeRegNoOrId.val().trim() === '' &&
            $('#conversationExchangeAd').val() === ''
        ) {
            $('.block_regno').addClass('error_highlight');
            return false;
        }

        let exchangeMake = $('#exchange_make');
        if (exchangeMake.is(':visible') && exchangeMake.val().trim() === '') {
            $('.block_make').addClass('error_highlight');
            return false;
        }

        let exchangeModel = $('#exchange_model');
        if (exchangeModel.is(':visible') && exchangeModel.val().trim() === '') {
            $('.block_model').addClass('error_highlight');
            return false;
        }

        let exchangeMileage = $('#exchange_mileage');
        if (exchangeMileage.is(':visible') && exchangeMileage.val().trim() === '') {
            $('.block_mileage').addClass('error_highlight');
            return false;
        }

        let exchangeYear = $('#exchange_year');
        if (
            (exchangeYear.is(':visible') && commonUtils.isEmpty(exchangeYear.val())) ||
            (!commonUtils.isEmpty(exchangeYear.val()) && Number.parseInt(exchangeYear.val(), 10) < 1901) ||
            (!commonUtils.isEmpty(exchangeYear.val()) &&
                Number.parseInt(exchangeYear.val(), 10) > new Date().getFullYear() + 3)
        ) {
            $('.block_year').addClass('error_highlight');
            return false;
        }

        return true;
    },
    success() {
        if (!adExchange.validate()) {
            return false;
        }

        let exchangeAd = $('#conversationExchangeAd option:selected').data('ad');
        let visibleFields = $('input[id^="exchange_"]:visible');
        let exchangeAdJson = {};
        exchangeAdJson.adId = $('#conversationExchangeRegNoOrId').val();
        $.each(visibleFields, function (_index, field) {
            exchangeAdJson[$(field).prop('id').split('_')[1]] = $(field).val();
        });
        exchangeAd = exchangeAd !== undefined ? exchangeAd : $('#conversationExchangeRegNoOrId').data('ad');

        if (exchangeAd) {
            let siteAndAd =
                $('#conversationExchangeAd').val() !== undefined ? $('#conversationExchangeAd').val().split('|') : [];

            exchangeAdJson.site = siteAndAd[0] || commonUtils.getVerticalName();
            exchangeAdJson.adId = siteAndAd[1] || exchangeAd.id;
            exchangeAdJson.adUrl = exchangeAd.adUrl;

            if (exchangeAd.registerNumber !== undefined && exchangeAd.registerNumber !== null) {
                $('#adExchangeIdRegNo').text(exchangeAd.registerNumber).show();
            } else {
                $('#adExchangeIdRegNo').text(exchangeAd.id).show();
            }
        } else {
            exchangeAdJson.site = commonUtils.getVerticalName();
            $('#adExchangeIdRegNo').text($('#exchange_make').val()).show();
        }

        $('#conversationExchangeAdJson').val(JSON.stringify(exchangeAdJson));
        globalThis.$.colorbox.close();

        return undefined;
    },
};

$(function () {
    let $body = $('body');

    // Seller ad open Inbox conversation
    $body.on('click', '.openConversationFrom', function (e) {
        e.preventDefault();
        globalThis.$.colorbox.close();
        $('#conversationFormBlock').show();
        sellerInboxConversation.openFrom();
    });

    // Validation on message input
    $body.on('keyup', '#conversationMessage', function () {
        $(this).closest('.highlightInput').removeClass('error_highlight');
    });

    // Inbox conversation form reset
    $body.on('reset', '#conversationForm', function () {
        $('#adExchangeIdRegNo').text('').hide();
        $('#conversationExchangeAdJson').val('');
        $('#conversationMessage').closest('.highlightInput').removeClass('error_highlight');
        $('#conversationFormBlock').hide();
    });

    // Inbox conversation form submit
    $body.on('submit', '#conversationForm', function () {
        return sellerInboxConversation.create($(this).serialize());
    });

    // Dealer ad open contact request form
    $body.on('click', '.openContactRequestForm', function () {
        $('#contactRequestFormBlock').show();
        dealerContactRequest.openForm();
    });

    // Dealer ad validate contact request fields
    $body.on('change blur', '.validateChange', function () {
        let errorField = dealerContactRequest.validateContactInfo(this.id);
        if (errorField) {
            $(`#${errorField}`).closest('.highlightInput').addClass('error_highlight');
            return false;
        }

        return undefined;
    });

    // Dealer ad hide exchange info on select other radio buttons
    $body.on('click', 'input[id^=contact_info]:not("[value=exchange]")', function () {
        $('#adExchangeIdRegNo').text('').hide();
        $('#conversationExchangeAdJson').val('');
    });

    // Validation on message input
    $body.on('keyup', '#crForm input[type=text], #crForm #message', function () {
        $(this).closest('.highlightInput').removeClass('error_highlight');
    });

    // Dealer ad contact request reset
    $body.on('reset', '#contactRequestForm', function () {
        $('#adExchangeIdRegNo').text('').hide();
        $('#conversationExchangeAdJson').val('');
        $('#contactRequestForm #message').closest('.highlightInput').removeClass('error_highlight');
        $('#contactRequestFormBlock').hide();
    });

    // Dealer ad contact request submit
    $body.on('submit', '#contactRequestForm', function (event) {
        let submitButton = $('#contactRequestForm input[type="submit"]');
        submitButton.prop('disabled', true);
        event.preventDefault();
        if (dealerContactRequest.validate()) {
            let params = $(this).serialize();
            dealerContactRequest.send(params);
        } else {
            submitButton.prop('disabled', false);
        }
        return false;
    });

    // Dealer ad show exchange form
    $body.on('click', '.showExchange', function () {
        if ($('#adExchangeIdRegNo').is(':visible')) {
            adExchange.showModal();
        } else {
            adExchange.getForm();
        }
    });

    // Check for show already opened exchange form or fetch new
    $body.on('change', '#conversationHasExchange', function () {
        if ($('#adExchangeIdRegNo').is(':visible')) {
            $(this).prop('checked', true);
            adExchange.showModal();
        } else if ($(this).is(':checked')) {
            adExchange.getForm();
        }
    });

    // Check ad exchange mandatory fields
    $body.on('input', '#conversationExchangeRegNoOrId, #exchange_make, #exchange_model', function () {
        $(this).parent().removeClass('error_highlight');
    });

    // Check ad exchange mandatory fields & correct integer fields
    $body.on('input', '#exchange_mileage, #exchange_year, #exchange_price', function () {
        $(this).parent().removeClass('error_highlight');
        commonUtils.allowInteger($(this));
    });

    // Ad exchange select own ad from list
    $body.on('change', '#conversationExchangeAd', function () {
        adExchange.selectOwnAd();
    });

    // Ad exchange cancel
    $body.on('click', '#conversationExchangeCancel', function () {
        adExchange.cancel();
    });

    // Ad exchange success after fill-up form
    $body.on('click', '#conversationExchangeOk', function () {
        adExchange.success();
    });

    // Ad exchange get ad detail by Id or Reg.no.
    $body.on('blur', '#conversationExchangeRegNoOrId', function (event) {
        commonUtils.typewatch(
            function () {
                adExchange.getAdByRegNoOrId();
            },
            event.type === 'blur' ? 3000 : 350
        );
    });

    // Dealer ad clear contact request block after successfully submit.
    $body.on('click', '#clearContactRequestBlock', function () {
        $('#contactRequestBlock').html('').hide();
        $('.dealerContactButtonHolder').removeClass('seller_make_sale_btn actived_contact_form');
        $('.vifContactBottomButton').removeClass('actived_contact_btn');
    });

    // Add after all Inbox & Contact Request events for open & scroll down to contact button.
    if ('#show_contact' === globalThis.location.hash) {
        if ($('.openLoginPopup').length) {
            // User is not logged in and has opened a seller's ad
            $('.openLoginPopup').click();
        } else if ($('.openContactRequestForm').length) {
            // User is logged in and has opened a dealer's ad
            $('.vifContactBottomButton').click();
        } else if ($('.openConversationFrom').length) {
            // User is logged in and has opened a seller's ad
            $('.openConversationFrom').click();
        }
    }
});
